// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getProp } from "@insite/mobius/utilities";
import { headerStyles } from "@west/Overrides/Pages/Header";
import { color, hideElement, xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

headerStyles.page = {
    css: css`
        background-color: ${color("common.white")};
        width: 100%;
        position: relative;
        z-index: ${getProp("theme.zIndex.header")};

        ${xScreen("lte", "md")} {
            box-shadow: 0 1px 0 0 ${color("common.ui4")};
        }

        ${({ isInShell, maxWidth }: any) => css`
            ${!isInShell &&
            css`
                &&&& {
                    position: fixed;
                    top: 0;
                }
            `}

            ${maxWidth &&
            css`
                max-width: ${typeof maxWidth !== "string" ? `${maxWidth}px` : maxWidth};
            `}
        `}
    `,
};

headerStyles.headerEmptyContainer = {
    css: css`
        background-color: ${color("common.ui14")};
        @media print {
            ${hideElement};
        }
    `,
};

headerStyles.container = {
    css: css`
        border-top: 1px solid ${color("common.border")};
        background-color: ${color("common.white")};
        box-shadow: 0 1px 0 0 ${color("common.ui4")};

        ${({ isCheckoutPages }: any) =>
            isCheckoutPages &&
            css`
                box-shadow: none;
            `}
    `,
};

headerStyles.printLogo = {
    css: css`
        display: none;
        @media print {
            display: block;
            padding: 0;
            margin: 0 15px;
            width: 100%;
        }
    `,
};

headerStyles.printLogoImage = {
    css: css`
        max-width: 110px;
        max-height: 110px;
    `,
};
